(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/document-title/assets/javascripts/document-title.js') >= 0) return;  svs.modules.push('/components/lb-utils/document-title/assets/javascripts/document-title.js');

'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
class DocumentTitle extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "confirmUpdate", () => {
      setTimeout(() => {
        const title = this.props.title;
        if (title && title !== document.title) {
          this.oldTitle = document.title;
          document.title = title;
        }
      }, 0);
    });
  }
  componentDidMount() {
    this.confirmUpdate();
  }
  componentDidUpdate() {
    this.confirmUpdate();
  }
  componentWillUnmount() {
    const title = this.props.title;
    if (this.oldTitle && document.title === title) {
      document.title = this.oldTitle;
    }
  }
  render() {
    return null;
  }
}
setGlobal('svs.components.lbUtils.DocumentTitle', DocumentTitle);

 })(window);